import React, {useEffect, useState} from 'react';
import {MdAdd} from 'react-icons/md';
import {IconContext} from 'react-icons';
import {Link, useLocation} from 'react-router-dom';

import {logOut} from '../../../utils/useToken';


/*const navItems = [
    {'type': 'Alcohol', 'id': '6734f550d28669ea1b8ece7d'},
    {'type': 'Caffeine', 'id': '67571379bccc4214bae0cd5f'},
    {'type': 'Food', 'id': '6738c9f2f51b96c3b7ead71c'},
    {'type': 'Paracetamol', 'id': '673530aa8f4434fecd7583ea'},
];*/


function NavDropdown({authFetch}) {
    const [navItems, setNavItems] = useState([]);
    const location = useLocation();


    useEffect(() => {
        if (!authFetch) return;

        const fetchUserTypes = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/type/all`);
            const data = await response.json();
            console.log('Nabar items: ', data);
            setNavItems(data);
        };

        fetchUserTypes();
    }, [authFetch]);

    return (
        <>
            <div className="topnav">
                <nav>
                    <a href="/">Dashboard</a>
                </nav>
                <nav>
                    <a href="/readings">All Readings</a>
                </nav>
                <nav>
                    <a href="/profile">My Profile</a>
                </nav>
                <nav>
                    <button onClick={logOut}>Logout</button>
                </nav>
            </div>
            <ul style={{listStyleType: 'none', textAlign: 'center'}}>
                {navItems.map((item) => {
                    const isCurrent = location.pathname.includes(`/type/${item._id}`);

                    return (
                        <li key={item._id} style={{float: 'left', padding: 10}}>
                            {isCurrent ? (
                                <span style={{color: 'black', fontWeight: 'bold'}}>{item.name}</span>
                            ) : (
                                <Link to={`/type/${item._id}`} style={{color: 'gray'}}>
                                    {item.name}
                                </Link>
                            )}
                        </li>
                    );
                })}
                <li key={'create-type'} style={{float: 'left', padding: 10}}>
                    <a href={'/create-type/'} style={{color: 'black'}} title={'Add New Type'}><IconContext.Provider
                        value={{size: '20', color: 'black'}}><MdAdd/></IconContext.Provider></a>
                </li>
            </ul>
        </>
    );
}

export default NavDropdown;